import type { GebiedLabel } from '@models/GebiedLabel'

import { apiClient } from '../../gateways/api'

export { createLabel }

const createLabel = async ({
  label,
}: {
  label: Omit<GebiedLabel, '_id' | 'gebiedscodeLabel'>
}): Promise<GebiedLabel> => {
  const { data } = await apiClient({
    url: `/rest/label`,
    method: 'POST',
    data: label,
  })

  return data
}
